<div class="pre-qualified" *transloco="let t">
	<op-back-link class="op-mt-20" id="preQualBck">{{ t('PRE_QUALIFIED.back') }}</op-back-link>
	<op-masthead [title]="t('PRE_QUALIFIED.title')"></op-masthead>
	<op-content-container class="content">
		<div [innerHTML]="t('PRE_QUALIFIED.details')"></div>
	</op-content-container>
</div>
